module.exports = __webpack_public_path__ + "img/bitcoin-alternative.6f4b203f.png";